import type { Board, BoardMembership } from '@trello/model-types';

export const getBoardAdmins = <
  Members extends Pick<Board['members'][number], 'id'>[],
  Memberships extends Pick<BoardMembership[number], 'idMember' | 'memberType'>[]
>(
  members: Members,
  memberships: Memberships,
): Members => {
  const adminMembershipsIds = new Set(
    memberships
      .filter(({ memberType }) => memberType === 'admin')
      .map(({ idMember }) => idMember),
  );

  return members.filter((member) =>
    adminMembershipsIds.has(member.id),
  ) as Members;
};
